import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import media from '../styles/media'

const StyledHamburger = styled.button`
  justify-self: flex-end;
  margin-right: 15px;
  width: 25px;
  border: none;
  background: none;
  padding: 0;
  display: none;

  ${media.md`
    display: block;
  `};

  :before,
  :after,
  div {
    background: black;
    content: "";
    display: block;
    height: 3px;
    border-radius: 3px;
    margin: 6px 0;
    transition: 0.5s;
  }
  ${(props) => props.isOpen && css`
    :before {
      transform: translateY(10px) rotate(135deg);
    }
    :after {
      transform: translateY(-8px) rotate(-135deg);
    }
    div {
      transform: scale(0);
    }
  `}
`

const Hamburger = ({state, ...rest}) => {
  useEffect(() => {
    if(state) {
      document.documentElement.style.overflow = 'hidden'
    } else {
      document.documentElement.style.overflow = 'auto'
    }
  }, [state])

  return (
    <StyledHamburger isOpen={state} {...rest} aria-label={"Hamburger menu"}>
      <div></div>
    </StyledHamburger>
  )
}

Hamburger.propTypes = {
  state: PropTypes.bool
}

export default Hamburger
